import { render } from "./ActivitiesItemView.vue?vue&type=template&id=0585501c"
import script from "./ActivitiesItemView.vue?vue&type=script&lang=js"
export * from "./ActivitiesItemView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__